import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import { Store } from "lucide-react";

export default function ForgotPasswordPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div className="text-center">
                    <div className="flex justify-center">
                        <div className="flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full">
                            <Store className="w-8 h-8 text-primary-600" />
                        </div>
                    </div>
                    <h2 className="mt-6 text-3xl font-bold text-gray-900">
                        Forgot Password
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Enter your registered email address and we’ll send you a link to reset your password.
                    </p>
                </div>

                <ForgotPasswordForm />
            </div>
        </div>
    );
}
